var React = require('react');

function CheckCircle (props) {
    return React.createElement("svg",props,React.createElement("g",{"fillRule":"nonzero","fill":"none"},[React.createElement("circle",{"fill":"#11D08A","cx":"12","cy":"12","r":"12","key":0}),React.createElement("path",{"fill":"#FFF","d":"M19 5.6L20.4 7 9 18.4 3.6 13 5 11.6l4 4z","key":1})]));
}

CheckCircle.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24"};

module.exports = CheckCircle;

CheckCircle.default = CheckCircle;
